var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: [_vm.prefixCls] },
    [
      _c(
        "div",
        {
          class: _vm.classes,
          on: {
            click: _vm.handleClick,
            drop: function($event) {
              $event.preventDefault()
              return _vm.onDrop.apply(null, arguments)
            },
            paste: _vm.handlePaste,
            dragover: function($event) {
              $event.preventDefault()
              _vm.dragOver = true
            },
            dragleave: function($event) {
              $event.preventDefault()
              _vm.dragOver = false
            }
          }
        },
        [
          _c("input", {
            ref: "input",
            class: [_vm.prefixCls + "-input"],
            attrs: {
              type: "file",
              multiple: _vm.multiple,
              webkitdirectory: _vm.webkitdirectory,
              accept: _vm.accept
            },
            on: { change: _vm.handleChange }
          }),
          _vm._v(" "),
          _vm._t("default")
        ],
        2
      ),
      _vm._v(" "),
      _vm._t("tip"),
      _vm._v(" "),
      _vm.showUploadList
        ? _c("upload-list", {
            attrs: { files: _vm.fileList },
            on: {
              "on-file-remove": _vm.handleRemove,
              "on-file-preview": _vm.handlePreview
            }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-34a60f25", { render: render, staticRenderFns: staticRenderFns })
  }
}